import { AwardsApi } from '../clients';
import { mapCycle } from '../mappers';

export const createCycle = async (payload) =>
  mapCycle(await AwardsApi.createCycle(payload));
